<script lang="ts" setup>
import { ContactFilter, ContactHealthStatus } from '@/types';
import { useI18n } from 'vue-i18n';

interface HealthFilterOption {
    label: string;
    value: ContactHealthStatus | null;
}

const { t } = useI18n();

defineProps<{
    modelValue: ContactFilter;
}>();

const emit = defineEmits<{
    (event: 'update:modelValue', value: ContactFilter): void;
}>();

const filters: HealthFilterOption[] = [
    { label: t('core.options.All'), value: null },
    { label: t('contact.timeline.stats.healthScore.healthy'), value: ContactHealthStatus.HEALTHY },
    {
        label: t('contact.timeline.stats.healthScore.attention'),
        value: ContactHealthStatus.ATTENTION,
    },
    { label: t('contact.timeline.stats.healthScore.atRisk'), value: ContactHealthStatus.AT_RISK },
];

const selectFilter = (health: ContactHealthStatus | null) => {
    emit('update:modelValue', { health });
};
</script>

<template>
    <div class="flex flex-wrap gap-1 rounded-md border border-gray-200 p-1">
        <button
            v-for="filter in filters"
            :key="filter.value ?? 'all'"
            type="button"
            :aria-pressed="modelValue.health === filter.value"
            class="rounded px-3 py-1.5 text-xs transition-colors"
            :class="
                modelValue.health === filter.value
                    ? 'bg-primary text-white'
                    : 'text-gray-500 hover:bg-gray-200'
            "
            @click="selectFilter(filter.value)"
        >
            {{ filter.label }}
        </button>
    </div>
</template>
